<div class="consultar-cliente-container">
  <div class="header">
    <h1>Consultar Cliente</h1>
    <button class="btn btn-primary" (click)="novoCliente()">Novo Cliente</button>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroCarteira">Sobrenome:</label>
          <input 
            type="text" 
            id="filtroCarteira" 
            class="form-control" 
            [(ngModel)]="filtros.carteira"
            (keyup)="pesquisarClientes()"
            placeholder="Filtrar por sobrenome">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroNome">Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtros.nome"
            (keyup)="pesquisarClientes()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label for="filtroEmail">Email:</label>
          <input 
            type="email" 
            id="filtroEmail" 
            class="form-control" 
            [(ngModel)]="filtros.email"
            (keyup)="pesquisarClientes()"
            placeholder="Filtrar por email">
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 text-end">
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Sobrenome</th>
          <th>Nome</th>
          <th>Email</th>
          <th>CPF</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let cliente of clientesPaginados">
          <td>{{ cliente.carteira }}</td>
          <td>{{ cliente.nome }}</td>
          <td>{{ cliente.email }}</td>
          <td>{{ cliente.cpf }}</td>
          <td>
            <button class="btn btn-sm btn-info me-2" (click)="verDetalhes(cliente)" title="Ver detalhes">
              <i class="fa fa-eye"></i> Ver
            </button>
            <button class="btn btn-sm btn-warning me-2" (click)="editarCliente(cliente)" title="Editar">
              <i class="fa fa-edit"></i> Editar
            </button>          
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Controles de Paginação -->
  <div class="pagination-container" *ngIf="totalPaginas > 1">
    <div class="row align-items-center">
      <div class="col-md-6">
        <div class="pagination-info">
          <span>Mostrando {{ (paginaAtual - 1) * itensPorPagina + 1 }} a {{ getFimItensExibidos() }} de {{ totalItens }} registros</span>
        </div>
      </div>
      <div class="col-md-3">
        <div class="items-per-page">
          <label for="itensPorPagina">Itens por página:</label>
          <select 
            id="itensPorPagina" 
            class="form-control form-control-sm" 
            [(ngModel)]="itensPorPagina"
            (change)="alterarItensPorPagina()">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <nav aria-label="Navegação da página">
          <ul class="pagination pagination-sm justify-content-end">
            <!-- Botão Anterior -->
            <li class="page-item" [class.disabled]="paginaAtual === 1">
              <a class="page-link" href="#" (click)="paginaAnterior(); $event.preventDefault()" 
                 [attr.aria-label]="'Página anterior'">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            
            <!-- Primeira página (se não estiver visível) -->
            <li class="page-item" *ngIf="paginaAtual > 3">
              <a class="page-link" href="#" (click)="irParaPagina(1); $event.preventDefault()">1</a>
            </li>
            <li class="page-item disabled" *ngIf="paginaAtual > 4">
              <span class="page-link">...</span>
            </li>
            
            <!-- Números das páginas -->
            <li class="page-item" 
                *ngFor="let numero of getNumerosPaginas()" 
                [class.active]="numero === paginaAtual">
              <a class="page-link" href="#" 
                 (click)="irParaPagina(numero); $event.preventDefault()">{{ numero }}</a>
            </li>
            
            <!-- Última página (se não estiver visível) -->
            <li class="page-item disabled" *ngIf="paginaAtual < totalPaginas - 3">
              <span class="page-link">...</span>
            </li>
            <li class="page-item" *ngIf="paginaAtual < totalPaginas - 2">
              <a class="page-link" href="#" (click)="irParaPagina(totalPaginas); $event.preventDefault()">{{ totalPaginas }}</a>
            </li>
            
            <!-- Botão Próximo -->
            <li class="page-item" [class.disabled]="paginaAtual === totalPaginas">
              <a class="page-link" href="#" (click)="proximaPagina(); $event.preventDefault()" 
                 [attr.aria-label]="'Próxima página'">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal de Cadastro de Cliente -->
  <app-modal-cadastro-cliente
    [isVisible]="modalCadastroVisible"
    [clienteEdicao]="clienteSelecionado"
    (modalClosed)="fecharModalCadastro($event)"
    (clienteSalvo)="onClienteSalvo($event)">
  </app-modal-cadastro-cliente>

  <!-- Modal de Visualização de Cliente -->
  <app-modal-visualizar-cliente
    [isVisible]="modalVisualizacaoVisible"
    [clienteDetalhes]="clienteDetalhes"
    (modalClosed)="fecharModalVisualizacao($event)">
  </app-modal-visualizar-cliente>
</div>
